import { deltaParts } from "../lib/proposalOverlay";
import type { FieldDelta } from "../lib/weekDelta";

/** ONE drawing of an exercise's moves — `60 → 62.5 kg · 8 → 9 reps` with ONLY `→ 62.5` in the accent (Fable, W72 step 2
 *  FIX 2). The Week's proposals overlay and the review's Next-week list both draw a move through this, so the two can
 *  never word next week differently. */
export function MoveParts({ moves }: { moves: readonly { delta: FieldDelta }[] }) {
  return (
    <>
      {moves.map((mv, i) => {
        const parts = deltaParts(mv.delta);
        return (
          <span key={i} className="proposal-move">
            {i > 0 && " · "}{parts.from} <span className="proposal-to">→ {parts.to}</span> {parts.unit}
          </span>
        );
      })}
    </>
  );
}
